export default {
    language: 'Language',
} as const;
